var _excluded = ["variant"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { BaseIcon } from '../internal';
import Rnaui105_32x32_4 from '../../png/Rnaui105_32x32_4.png';
export var rnaui105Data = {
  '32x32_4': {
    imageSrc: Rnaui105_32x32_4,
    width: 32,
    height: 32
  }
};
export var Rnaui105 = function Rnaui105(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '32x32_4' : _ref$variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  var image = rnaui105Data[variant];
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    width: image.width,
    height: image.height,
    src: image.imageSrc
  }, rest));
};